module.exports = __webpack_public_path__ + "static/media/radio_off.cca68232.svg";